module.exports = __webpack_public_path__ + "static/img/336befd479c7e72c0f201e58cf40ef2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon7.png
// module id = 9dHK
// module chunks = 1